<template>
  <div>
    <form
      ref="form"
      @submit.prevent="checkForm"
    >
      <!-- 모달 컨텐츠 -->
      <div class="modal__contents">
        <div class="modal__middlebox">
          <div class="modal__row">
            <h2 class="subtitle subtitle--modal">
              프로젝트 일정을 알려주세요
            </h2>
          </div>
          <div class="modal__row">
            <div class="formfield">
              <ul class="formfield__row">
                <li class="formfield__inputitem">
                  <label
                    class="formfield__label formfield__label--date"
                    for="start"
                  />
                  <Datepicker
                    :id="'start'"
                    v-model="req.period.start"
                    :input-class="'formfield__input formfield__input--date'"
                    :autocomplete="'off'"
                    :disabled="req.period.tbd"
                    :format="calendarConfig.format"
                    :disabled-dates="periodStartMinDate.disabledDates"
                    :placeholder="'시작일'"
                    @input="resetPeriodEnd"
                  />
                </li>
                <li class="formfield__inputitem">
                  <label
                    class="formfield__label formfield__label--date"
                    for="end"
                  />
                  <Datepicker
                    :id="'end'"
                    v-model="req.period.end"
                    :input-class="'formfield__input formfield__input--date'"
                    :autocomplete="'off'"
                    :disabled="req.period.tbd"
                    :format="calendarConfig.format"
                    :placeholder="'종료일'"
                    :disabled-dates="periodEndMinDate.disabledDates"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="modal__bottombox">
          <div class="checkbox">
            <input
              id="check"
              v-model="req.period.tbd"
              class="checkbox__input"
              type="checkbox"
              name="check"
            >
            <label
              class="checkbox__label"
              for="check"
            >
              아직 결정되지 않았습니다.
            </label>
          </div>
        </div>
      </div>
      <!-- 모달 푸터(bottom) -->
      <div class="modal__footer">
        <ul class="modal__buttons">
          <li class="modal__buttonitem">
            <button
              type="button"
              class="button button--large button--secondary"
              @click="save"
            >
              임시저장
            </button>
          </li>
          <li class="modal__buttonitem">
            <button
              class="button button--large"
              :disabled="!req.period.tbd && (!req.period.start || !req.period.end)"
            >
              다음
            </button>
          </li>
        </ul>
      </div>
      <!-- 모달 이전 -->
      <div class="modal__prevbutton">
        <button
          type="submit"
          class="button button--function"
          @click="$emit('prev-step')"
        >
          이전
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
export default{
  name:'Period',
  components: {
    Datepicker
  },
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  emits: ['prev-step', 'next-step', 'save-click'],
  data(){
    return {
      req: this.request,
      calendarConfig: {
        format: 'yyyy.MM.dd',
      },
    }
  },
  computed: {
    periodStartMinDate() {
      return {
        disabledDates: {
          to: new Date(),
          // days: [6, 0] 요일
        }
      }
    },
    periodEndMinDate() {
      return {
        disabledDates: {
          to: this.req.period.start,
          // days: [6, 0] 요일
        }
      }
    }
  },
  methods:{
    checkForm() {
      console.log(this.req)
      this.$emit('next-step')
    },
    resetPeriodEnd(date) {
      // console.log(date)
      // this.req.period.end = this.req.period.start
    },
    save() {
      this.$emit('save-click')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal{
  $self:&;
  &__buttons{
    width:330px;
    margin:0 auto;
    &:after{
      content:'';
      clear:both;
      display:inline;
    }
  }
  &__buttonitem{
    float:left;
    width:160px;
    height:50px;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
.formfield{
  &__row{
  width:490px;
  margin:0 auto;
}
  &__inputitem{
    float:left;
    width:240px;
    height:50px;
    position: relative;
    text-align:left;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}

</style>